import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { appClient } from "config/axios";
import PATHS from "config/paths";
import { QueryKeys } from "config/query-keys";

export const markAllNotificationRead = (): Promise<{}> => {
  return appClient.httpClient.put(`${PATHS.notificationService.baseURL}/mark-all-as-read`);
};

export const useMarkAllNotificationRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: async (data, __, ___) => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.NOTIFICATIONS] });
      notification.success({
        message: "Marked as read.",
        description: "All notifications has been succesfully marked read.",
        duration: 2,
      });
    },

    mutationFn: markAllNotificationRead,
  });
};
